import React from 'react';

export default function CareerGrowthLogo({ className = '', hideText = false, size = 40 }) {
  const iconSize = Math.round(size * 0.6);
  return (
    <div className={`flex items-center gap-3 select-none group ${className}`}>
      <div 
        style={{ width: size, height: size }}
        className="relative flex items-center justify-center bg-orange-500 rounded-xl shadow-lg shadow-orange-500/20 group-hover:shadow-orange-500/30 transition-all duration-300"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          style={{ width: iconSize, height: iconSize }}
          className="text-white"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      </div>

      {!hideText && (
        <span className="text-xl font-bold tracking-tight text-slate-900">
          Job<span className="text-orange-600">Skills</span>
        </span>
      )}
    </div>
  );
}
